export default __webpack_public_path__ + "static/mentions-2-a06566e0915399c1c7943081644c848b.png";